export const acaraViolet = 'rgba(111, 88, 255, 1)';
export const acaraVioletHover = 'rgba(72, 53, 198, 1)';
export const mainText = 'rgba(39, 39, 39, 1)';
export const secondaryText = 'rgba(89, 89, 89, 1)';
export const tertiaryText = 'rgba(152, 152, 152, 1)';
export const backgroundColor = 'rgba(247, 248, 253, 1)';
export const primaryTextInvert = 'rgba(255, 255, 255, 1)';
export const lightViolet = 'rgba(239, 238, 255, 1)';
export const lightVioletHover = 'rgba(211, 204, 255, 1)';
export const lightVioletSemiTransparent = 'rgba(111, 88, 255, 0.1)';
export const lightVioletSemiTransparentHover = 'rgba(111, 88, 255, 0.3)';
export const thinStroke = 'rgba(225, 227, 244, 1)';

export const warningColor = 'rgba(255, 98, 86, 1)';
export const warningColorHover = 'rgba(204, 54, 0, 1)';
export const acceptColor = 'rgba(0, 206, 117, 1)';
export const acceptColorHover = 'rgba(0, 149, 69, 1)';

export const disabledColor = 'rgba(213, 213, 213, 1)';
export const disabledBackground = 'rgba(250, 249, 247, 1)';

export const iconDefault = 'rgba(95, 93, 109, 1)';
export const iconActive = 'rgba(11, 88, 255, 1)';
export const iconOff = 'rgba(201, 201, 210, 1)';

export const cardBackground = 'rgba(255, 255, 255, 1)';
